import { render, staticRenderFns } from "./GaleriGuncelle.vue?vue&type=template&id=6242513e&scoped=true&"
import script from "./GaleriGuncelle.vue?vue&type=script&lang=js&"
export * from "./GaleriGuncelle.vue?vue&type=script&lang=js&"
import style0 from "./GaleriGuncelle.vue?vue&type=style&index=0&id=6242513e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6242513e",
  null
  
)

export default component.exports